var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-icon',[_c('select-color',{attrs:{"value":_vm.value.color},on:{"input":_vm.changeColor}})],1),_c('v-list-item-content',[_vm._v(" "+_vm._s(_vm.value.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }